import React from "react";
import PropTypes from "prop-types";
import format from "date-fns/format";
// Material imports
import Grid from "@mui/material/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import makeStyles from "@mui/styles/makeStyles";
import Chip from "@limitless/modern/data-display/chip/Chip";

const useStyles = makeStyles(theme => ({
    chip: {
        backgroundColor: theme.palette.secondary.light,
        borderRadius: "8px",
        marginBottom: theme.spacing(2),
        display: "flex",
        alignItems: "flex-start",
        whiteSpace: "nowrap"
    }
}));

const ExpertWaitingListMessage = ({ endDate }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const formattedDate = `${format(endDate, "Do MMM, YYYY ")} at ${format(endDate, "hh:mma")}`;

    return (
        <Grid container item gap={"16px"} width={"390px"}>
            <Chip className={classes.chip} label={t("Onboarding for this brand closed on {0}", formattedDate)} />
            <Typography variant="body2" color="textSecondary">
                {
                    "Onboarding for this brand is currently closed, since we have enough experts. You are on the waiting list and we will let you know if and when it re-opens."
                }
            </Typography>
        </Grid>
    );
};

ExpertWaitingListMessage.propTypes = {
    endDate: PropTypes.number.isRequired
};

export default ExpertWaitingListMessage;
